module.exports = __webpack_public_path__ + "img/plsdlogov2-modified.7d13acc1.png";